import React from 'react';

export default function CostPage({ cost = [] }) {
    // Sort by month ascending and keep at most the last 12 months
    const data = [...cost]
        .sort((a, b) => new Date(a.month) - new Date(b.month))
        .slice(-12);

    const amounts = data.map((d) => parseFloat(d.amount) || 0);
    const max = Math.max(...amounts, 0.000001);

    const labels = data.map((d) => {
        const dt = new Date(d.month);
        return dt.toLocaleString(undefined, { month: 'short', year: '2-digit' });
    });

    console.log({ data, amounts, max, labels });

    return (
        <div className="flex flex-col items-center justify-center flex-grow gap-4 lg:p-4">
            <h1 className="text-1xl font-thin font-semibold text-gray-900 sm:text-2xl lg:text-3xl">
                AWS Cost Reports
            </h1>

            <div className="w-full max-w-4xl bg-white p-2 lg:p-4 mt-10 rounded shadow">
                {data.length === 0 ? (
                    <div className="text-sm text-gray-600">No cost data available.</div>
                ) : (
                    <div className="flex gap-2 lg:gap-4 h-56">
                        {data.map((d, i) => {
                            const amt = parseFloat(d.amount) || 0;
                            const heightPercent = (amt / max) * 100;
                            console.log({ amt, heightPercent });
                            return (
                                <div key={d.month} className="flex-1 flex flex-col items-center">
                                    <div className="flex-1 w-full flex justify-center items-end py-2 text-sm lg:text-lg">
                                        {amt.toFixed(2)} €
                                    </div>
                                    <div
                                        title={`${labels[i]} — $${amt.toFixed(2)}`}
                                        style={{ height: `${heightPercent}%` }}
                                        className="w-full bg-blue-500 rounded-t transition-all"
                                    />
                                    <div className="mt-2 text-xs text-gray-600">{labels[i]}</div>
                                </div>
                            );
                        })}
                    </div>
                )}

                <div className="mt-4 text-xs text-gray-500">
                    Showing up to 12 months. Bars scaled to the largest month.
                </div>
            </div>

            { /* total */ }
            <div className="w-full max-w-4xl p-4 text-right text-gray-700 font-medium">
                Total Cost: {amounts.reduce((sum, val) => sum + val, 0).toFixed(2)} €
            </div>
            
        </div>
    );
}
